export const unhandledCase = (value: never): never => {
  throw new Error(`Unhandled case: ${value}`);
};
